export const googleAnalyticsConstants = {
  CONNECT: 'google/analytics/CONNECT',
  CREATE_EVENT: 'google/analytics/CREATE_EVENT',
};
